export function hasWhiteSpace(str) {
    return /\s/g.test(str);
}

export function isEmpty(str){
    return !/\S/.test(str)
}